export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_weddinginvitations-831f786dcafeeb9666711790e0e379e0.jpg";